import { useSuspenseQuery } from "@tanstack/react-query";
import { myAccountApi } from "@/features/my-account/api";
import { UserInfo } from "@/features/my-account/types";

const useGetUserInfo = (userId?: number) => {
  const { data: userInfo } = useSuspenseQuery<UserInfo>({
    queryKey: ["my-account", "user", userId],
    queryFn: () =>
      userId
        ? myAccountApi.getUserInfo(userId)
        : Promise.resolve({} as UserInfo),
  });

  return {
    userInfo,
  };
};

export default useGetUserInfo;
